import { apiSlice } from '../app/api/apiSlice';
import { addbuyingEmails, setBuyingEmailsList, addBuyingEmail } from '../store/slices/buyingEmails/buyingEmails';
import queryString from 'query-string';

export const buyingEmailApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({

    buyingEmail: builder.query({
      query: (params) => 'buyingEmail' + (params || ""),
      // every time the query is dispatched, this function will be called
      // so we can set the state on the store here instead of in the component
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        // `onStart` side-effect
        console.log('getBuyingEmails, start...')
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('getBuyingEmails, success: ', data)
          dispatch(setBuyingEmailsList(data))
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('getBuyingEmails, error: ', err)
          throw err
        }
      },
      providesTags: (result, error, arg)=>[
        {type:'buyingEmail', id: 'LIST'},
      ]
    }),
    getBuyingEmailPaged: builder.query({
      query: (query) => `buyingEmail/paged${query ? `?${queryString.stringify(query)}` : ''}`,
      providesTags: ['buyingEmailPaged']
    }),
    getBuyingEmailWithPlatforms: builder.query({
      query: (query) => {

        console.log("getBuyingEmailWithPlatforms: ", query)

        return `buyingEmail/with-platforms${query ? `?${queryString.stringify(query)}` : ''}`
      },
      providesTags: ['buyingEmailWithPlatforms'],

      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        // `onStart` side-effect
        console.log('getBuyingEmails, start...')
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('getBuyingEmails, success: ', data)
          dispatch(addbuyingEmails(data))
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('getBuyingEmails, error: ', err)
          throw err
        }
      },

    }),
    createBuyingEmail: builder.mutation({
      query: (newBuyingEmail)=>({
        url: '/Credential/buyingEmail',
        method: 'post',
        body: newBuyingEmail
      }),
      invalidatesTags: ["buyingEmailPaged"],
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        // `onStart` side-effect
        console.log('createBuyingEmails, start...')
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('createBuyingEmails, success: ', data)
          dispatch(addBuyingEmail({
            id: data.buyingEmail.id,
            emailAddress: data.buyingEmail.emailAddress,
            isActive: data.buyingEmail.isActive,
            isDeleted: data.buyingEmail.isDeleted,
            assignedUserID: data.buyingEmail.assignedUserID,
            assignedUserName: `${data.buyingEmail.assignedUser.firstName} ${data.buyingEmail.assignedUser.lastName}`,
            createdByUser: `${data.buyingEmail.createdByUser.firstName} ${data.buyingEmail.createdByUser.lastName}`,
            createdByUserID: data.buyingEmail.createdByUser.id,
            createdOn: data.buyingEmail.createdOn,
            modifiedByUser: `${data.buyingEmail.modifiedByUser.firstName} ${data.buyingEmail.modifiedByUser.lastName}`,
            modifiedByUserID: data.buyingEmail.modifiedByUser.id,
            modifiedOn: data.buyingEmail.modifiedOn,
            platformCredentials: data.platformCredentials.map(platformCredentials => ({
              id: platformCredentials.id,
              platformId: platformCredentials.platformId,
              platformPassword: platformCredentials.platformPassword,
              platformName: platformCredentials.platform.name,
              shortName: platformCredentials.shortName,
              isDeleted: platformCredentials.isDeleted
            }))
          }));
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('createBuyingEmails, error: ', err)
          throw err
        }
      },
    }),
    decryptEmailPassword: builder.query({
      keepUnusedDataFor: 0, 
      query: (id) => '/CreditCard/DecryptBuyingEmail/' + id
    }),
    updateEmail: builder.mutation({
      keepUnusedDataFor: 0, 
      query: (newBuyingEmail)=>({
        url: '/Credential/buyingEmail',
        method: 'put',
        body: newBuyingEmail
      }),
      invalidatesTags: ["buyingEmailPaged", "buyingEmailWithPlatforms"]
      }),
    getFullBuyingEmailDataForUser: builder.query({
      query: (id) => `/CreditCard/BuyingEmails?assignedUserId=${id}`,
      keepUnusedDataFor: 0,
    }),
  })
})

export const { 
  useUpdateEmailMutation, 
  useGetBuyingEmailPagedQuery, 
  useDecryptEmailPasswordQuery, 
  useLazyDecryptEmailPasswordQuery, 
  useLazyGetBuyingEmailWithPlatformsQuery,
  useGetBuyingEmailWithPlatformsQuery,
  useBuyingEmailQuery, 
  useCreateBuyingEmailMutation, 
  useGetFullBuyingEmailDataForUserQuery } = buyingEmailApi;
